// extracted by mini-css-extract-plugin
export default {"image-container":"image-container___ufJhK","image":"image___arDbo","contain":"contain___qvvHt","cover":"cover___5GXVQ"};